"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var App_1 = require("../../App");
var mobx_react_1 = require("mobx-react");
var buttons_1 = require("../buttons");
var urls_1 = require("../../urls");
var react_qr_code_1 = require("react-qr-code");
var TwoFactorAuthApp = (function (_super) {
    __extends(TwoFactorAuthApp, _super);
    function TwoFactorAuthApp(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            pairing: false,
            code: "",
        };
        return _this;
    }
    TwoFactorAuthApp.prototype.pairTwoFactor = function () {
        var _this = this;
        this.setState({ pairing: true, code: "" });
        $.get(urls_1.Urls.api_user_pair_2fa).then(function (response) {
            _this.setState({ pairing: true, code: response.code });
        });
    };
    TwoFactorAuthApp.prototype.enableTwoFactor = function () {
        var _this = this;
        $.post(urls_1.Urls.api_user_enable_2fa).then(function (response) {
            App_1.store.fetchMe();
            _this.setState({ pairing: false, code: "" });
        });
    };
    TwoFactorAuthApp.prototype.disableTwoFactor = function () {
        var _this = this;
        $.post(urls_1.Urls.api_user_disable_2fa).then(function (response) {
            App_1.store.fetchMe();
            _this.setState({ pairing: false, code: "" });
        });
    };
    TwoFactorAuthApp.prototype.render = function () {
        var user = App_1.store.getMe();
        if (!user)
            return null;
        var stage = 0;
        if (this.state.pairing && this.state.code)
            stage = 1;
        if (user.two_factor)
            stage = 2;
        return (React.createElement(React.Fragment, null,
            React.createElement("h5", null, gettext("Two-Factor Authentication")),
            stage == 0 ? (React.createElement(React.Fragment, null,
                React.createElement("div", { className: "alert alert-danger w-100", role: "alert" }, gettext("NOT ACTIVATED")),
                React.createElement(buttons_1.Button, { onClick: this.pairTwoFactor.bind(this), fullWidth: true, disabled: this.state.pairing },
                    this.state.pairing && (React.createElement(React.Fragment, null,
                        React.createElement("span", { className: "spinner-border spinner-border-sm mb-1", role: "status", "aria-hidden": "true" }),
                        " ")),
                    gettext("Enable Two-Factor Authentication")))) : stage == 1 ? (React.createElement(React.Fragment, null,
                React.createElement(react_qr_code_1.default, { size: 200, value: "otpauth://totp/".concat(user.first_name, "%20").concat(user.last_name, "?secret=").concat(this.state.code, "&issuer=RamRisk") }),
                React.createElement("p", { className: "pt-2" }, gettext("Please scan this QR code with an authenticator " +
                    "app on your device, then complete activation. " +
                    "(Please see manual for supported authenticator apps.)")),
                React.createElement(buttons_1.BlockButton, { onClick: this.enableTwoFactor.bind(this) }, gettext("Complete Activation")))) : (stage == 2 && (React.createElement(React.Fragment, null,
                React.createElement("div", { className: "alert alert-success w-100", role: "alert" }, gettext("ACTIVATED")),
                React.createElement(buttons_1.BlockButton, { onClick: this.disableTwoFactor.bind(this) }, gettext("Disable Two-Factor Authentication")))))));
    };
    TwoFactorAuthApp = __decorate([
        mobx_react_1.observer
    ], TwoFactorAuthApp);
    return TwoFactorAuthApp;
}(React.Component));
exports.default = TwoFactorAuthApp;
